import Auth from '../Containers/Authentication/Auth';
import Api from './Api';

class FirstFuelFarm {
  getId() {
    return localStorage.firstFuelfarmId;
  }
  get(params = {}) {
    const myHeaders = new Headers();
    const endPoint = `v1/fbos/${params.fboId}/fuel_farms`;

    myHeaders.append('X-Api-Key', Auth.getBearerToken());

    return Api.get(endPoint, {
      headers: myHeaders,
    }).then((response) => {
      const fuelFarms = response.fuelFarms;

      return fuelFarms[0];
    });
  }
}

export default new FirstFuelFarm();



// WEBPACK FOOTER //
// ./src/Services/FirstFuelFarm.js